import { Component, OnInit } from '@angular/core';
import { ImageUploadService } from '@app/services/image-upload/image-upload.service';
import { LimitAccessService } from '@app/core/services/limit-access.service';

@Component({
  selector: 'app-client-logo',
  templateUrl: './client-logo.component.html',
  styleUrls: ['./client-logo.component.scss']
})
export class ClientLogoComponent implements OnInit {
  public imageUpload$: string;
  public isNull:boolean = false;
  public isLoading$: boolean = true;
  public resultTierIdExpose: any = 0;

  constructor(
    public _imageUpload: ImageUploadService,
    private limitAccessService: LimitAccessService
  ) { }

  ngOnInit(): void {
    this.limitAccessService.tierID$.subscribe((tierID) => {
      if (tierID) {
        let resultTierID = this.limitAccessService.getTierId();
        this.resultTierIdExpose = resultTierID;

        if(this.resultTierIdExpose == 1){
          const secondary = document.querySelector('button');
          this.isNull = true;
          this.imageUpload$ = './../../assets/freemium_logo.svg';
        }else if(typeof this.resultTierIdExpose !== 'undefined'){

          this._imageUpload.onGetLogo();
          this._imageUpload.imageLogo$.subscribe(res => {
            if(!res){
    
              const secondary = document.querySelector('button');
              this.isNull = true;
              this.imageUpload$ = './../../assets/default-trakr-logo.svg';
            }else{
              this.imageUpload$ = res;
            }
            
            this.isLoading$ = false;
          });
        }
      }
    });

  }
}
